import { useGlobalState } from '@highlight/ipc/react'
import { clearCurrentDetection, DetectedType } from '@shared/store/impl/detection.ts'
import { useCallback, useMemo } from 'react'

export const useSelectedTextActivity = () => {
  const [detection] = useGlobalState<DetectedType>('currentDetection')

  const selectedText = useMemo(() => {
    if (detection?.type !== 'selectedText') {
      return undefined
    }
    return detection?.value !== undefined
  }, [detection])

  const clearSelectedText = useCallback(() => {
    clearCurrentDetection('selectedText')
  }, [])

  return useMemo(() => {
    return {
      selectedText,
      clearSelectedText,
    }
  }, [selectedText, clearSelectedText])
}
